import * as bootstrap from 'bootstrap';

import 'sharer.js/sharer.min.js';

import './components/script.js';
import './components/init_flatpickr.js'
import './components/zip-autocomplete.js'
import './components/form-payfip.js'
import './components/zip-station-autocomplete.js'

import Animations from './components/animations';
import Slab_Masonry from './components/masonry';
import LoadMore from './components/load-more';
import Player from './components/player';
import Slider from './components/slider';
import Selects from './components/selects';
import Forms from './components/forms';

const initScripts = () => {
    new Animations();
    new Slab_Masonry();
    new LoadMore();
    new Player();
    new Slider();
    new Selects();
    new Forms();
}

document.addEventListener("DOMContentLoaded", function () {
    initScripts();
});
